<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.21,782.5l-0.01,0c0.1,0,0.2,0,0.31,0c5.52,0,10,4.48,10,10l0,0v0c0,0.01,0,0.02,0,0.03c0,2.75-1.12,5.24-2.93,7.04
	c-0.18,0.18-0.37,0.36-0.56,0.52l0-0.01c0.08,0.17,0.12,0.36,0.12,0.55c0,0.72-0.58,1.31-1.31,1.31c-0.39,0-0.73-0.17-0.97-0.44
	l0.06-0.03c-1.33,0.65-2.82,1.02-4.4,1.02c-5.52,0-10-4.48-10-10c0-2.76,1.12-5.26,2.93-7.07l0,0
	C-4.83,783.69-2.45,782.58,0.21,782.5L0.21,782.5z M0.56,783.15L0.56,783.15c-0.02,0-0.05,0-0.08,0c-5.16,0-9.34,4.18-9.34,9.34
	s4.18,9.34,9.34,9.34c1.48,0,2.88-0.34,4.06-0.93l0,0.01c-0.02-0.08-0.03-0.17-0.03-0.26c0-0.72,0.58-1.31,1.31-1.31
	c0.28,0,0.54,0.09,0.74,0.23l0.01-0.01c0.18-0.15,0.35-0.31,0.51-0.47h0c1.69-1.69,2.73-4.02,2.73-6.6
	C9.82,787.36,5.68,783.2,0.56,783.15L0.56,783.15z M0.21,785.88l-0.01,0c0.1,0,0.2-0.01,0.3-0.01c1.53,0,2.94,0.52,4.04,1.38H4.48
	l-1.34,2.77l0.31,1.19l1.03-0.68l0.03,1.18l-1.06,1.96l0.48,0.64l2.42-2.21l0.5-1.47l-0.01-0.05c0.18,0.6,0.28,1.25,0.28,1.91
	c0,3.66-2.97,6.63-6.63,6.63c-2.31,0-4.34-1.18-5.54-2.99l1,0.31l0.29-0.34l-0.32-0.99l-0.71-0.8l-0.37-0.91l0.14-1.13l0.43-0.88
	l0.83,0.11v1.02l0.45,0.56h1.11l0.26-0.53l0.71-0.29l0.82,0.23l0.54-0.79l-0.2-0.32l-0.6-0.84l1.16-0.23l0.37-0.51l-0.6-0.6
	l-1.16-0.57L-2,788.73l-0.88,0.2l-0.34-0.71H-4.3v-0.29l0,0C-3.16,786.73-1.57,785.96,0.21,785.88L0.21,785.88z M-1.53,793.79
	L-2.08,795l0.58,1.61l1.27,0.73l0.57,1.31l0.84-0.5l0.2-2.17l1.29-1.21l-0.26-1.27l-0.81-0.19L-1.53,793.79z"/>
</svg>

</template>